$(function () {

	$('[data-toggle="datepicker"]').datepicker({
		language: 'fr-FR',
		autoHide: true,
		zIndex: 9999
	});

	$('[data-toggle="datepickerbottombar"]').datepicker({
		language: 'fr-FR',
		autoHide: true,
		zIndex: 9999,
		template: '<div class="datepicker-container datepicker-container-fixed"><div class="datepicker-panel" data-view="years picker"><ul><li data-view="years prev">&lsaquo;</li><li data-view="years current"></li><li data-view="years next">&rsaquo;</li></ul><ul data-view="years"></ul></div><div class="datepicker-panel" data-view="months picker"><ul><li data-view="year prev">&lsaquo;</li><li data-view="year current"></li><li data-view="year next">&rsaquo;</li></ul><ul data-view="months"></ul></div><div class="datepicker-panel" data-view="days picker"><ul><li data-view="month prev">&lsaquo;</li><li data-view="month current"></li><li data-view="month next">&rsaquo;</li></ul><ul data-view="week"></ul><ul data-view="days"></ul></div></div>'
	});

});